module.exports = __webpack_public_path__ + "static/media/mandy-icon.8c520916.png";